import React, { useState, useEffect } from "react";
import "./joinChatSection.css";
import "./form.css";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
const JoinNetwork = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pincode, setPincode] = useState("");
  const [profession, setProfession] = useState("");

  const validateForm = () => {
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return false;
    }

    // Phone number validation (10 digits India)
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Please enter a valid 10-digit phone number");
      return false;
    }

    // Pincode validation (6 digits India)
    const pincodeRegex = /^\d{6}$/;
    if (!pincodeRegex.test(pincode)) {
      toast.error("Please enter a valid 6-digit pincode");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const data = await axios.post(
        " https://adminmestry.tannis.in/api/contact/",
        {
          first_name: name,
          email,
          phone,
          pincode,
          profession,
          message: "Hello",
        }
      );
      toast.success(
        "Thanks for submitting your enquiry. Our team will contact you soon."
      );

      setName("");
      setEmail("");
      setPhone("");
      setPincode("");
      setProfession("");
      // navigate("/services");
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  };

  return (
    <div className="container-fluid join-chat-section  join-section-overlay  ">
      <div className="container joinContainer">
        <div className="row chat-content  d-flex justify-content-around">
          <div className="col-md-12 col-lg-6 my-xl-4 my-xxl-5 my-lg-5 my-md-3 my-sm-2 my-2  joinMargin ">
            <h3 className="abtMetsryh1 text-center my-2">
              Are you a skilled professional?
            </h3>

            <div className="d-flex justify-content-center my-xl-3 my-xxl-3 my-lg-3  my-1">
              <p className="joinP text-center">
                Elevate your business by joining Mestry Circle as a Service
                Expert. Showcase your skills, connect with homeowners, and grow
                your professional network. Become a trusted member today!
              </p>
            </div>

            <div className="text-center my-xl-4 my-xxl-4 my-lg-3  my-2">
              {" "}
              <button className="joinBtn">Join Our Professional Network</button>
            </div>
          </div>
          <div className="col-md-8 col-sm-10  col-lg-5">
            <div className="  p-xl-3  p-xxl-3  p-lg-3  p-md-3  p-sm-1 p-0 my-3 my-lg-4 my-xl-4 my-md-3 my-sm-3">
              <div className="card p-2 shadow signUpCard contactForm">
                {/* Close Icon */}

                <h4 className="text-center loginMain my-2 my-xl-3 my-lg-3 my-md-3 my-sm-3">
                  {" "}
                  Let’s chat with <span className="loginSpan">our team.</span>
                </h4>
                <form
                  onSubmit={handleSubmit}
                  className="px-2 px-sm-3 px-md-3 px-lg-4"
                >
                  <div className="col-12  mb-3">
                    <label className="form-label formLabel m-0">
                      Fisrt Name <span className="spanLogin">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <label className="form-label formLabel m-0">
                      Email Address <span className="spanLogin">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div>
                    <label className="form-label formLabel m-0">
                      Phone number <span className="spanLogin">*</span>
                    </label>
                    <div className="input-group mb-3 d-flex gap-2  p-0 p-sm-1 p-md-1 p-lg-1">
                      <input
                        type="text"
                        className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label className="form-label formLabel m-0">
                      Pincode <span className="spanLogin">*</span>
                    </label>
                    <div className="input-group mb-3 d-flex gap-2  p-0 p-sm-1 p-md-1 p-lg-1">
                      <input
                        type="text"
                        className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                        value={pincode}
                        onChange={(e) => setPincode(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12  mb-3">
                    <label className="form-label formLabel m-0">
                      Profession <span className="spanLogin">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                      value={profession}
                      onChange={(e) => setProfession(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input signupCheckbox p-0 p-sm-1 p-md-1 p-lg-1"
                      type="checkbox"
                      id="flexCheckChecked"
                      defaultChecked
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked"
                    >
                      <span className="signUpSpan">
                        By continuing, you agree to Mestry circle
                      </span>
                      <Link to="/terms-conditions" className="singupLink2">
                        Terms of Use
                      </Link>{" "}
                      and{" "}
                      <Link to="/privacy-policy" className="singupLink2">
                        Privacy Policy
                      </Link>
                      .
                    </label>
                  </div>

                  <div className="text-center mb-3">
                    <button className="loginBtn w-100">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinNetwork;
